{
	"sections": {
		"overview": "Overview",
		"operations": "Operations",
		"administration": "Administration",
		"accreditation": "Accreditation",
		"logistics": "Logistics & Hospitality",
		"sector1": "Sector 1",
		"sector2": "Sector 2",
		"sector3": "Sector 3",
		"sector4": "Sector 4",
		"merchandising": "Merchandising",
		"changelog": "Change Logs"
	},
	"groups": {
		"settings": "Game Settings",
		"users": "Users",
		"profile": "My Profile",
		"sectorEntries": "Entries",
		"sectorAccreditation": "Accreditation",
		"sectorLogistics": "Logistics",
		"sectorContingent": "Contingent"
	},
	"items": {
		"dashboard": "Dashboard",
		"viewRecords": "View Records",
		"expressionOfInterest": "Expression of Interest (EOI)",
		"entryByNumber": "Entry by Number (EBN)",
		"shortlist": "Shortlist",
		"acCardPrinting": "AC Card Printing",
		"accommodation": "Accommodation",
		"incidentHelpdesk": "Incident Helpdesk",
		"inventory": "Inventory",
		"wslInventory": "WSL Inventory",
		"reports": "Central Report Engine",
		"countries": "Countries",
		"responsibleOrganizations": "Responsible Organizations",
		"subAgencies": "Sub Agencies",
		"affiliatedOrganizations": "Affiliated Organizations",
		"functions": "Main / Sub Functions",
		"sports": "Sports",
		"events": "Events",
		"venues": "Venues",
		"sportClasses": "Para classes",
		"viewUsers": "View Users",
		"modules": "Modules",
		"userGroups": "User Groups",
		"signInLog": "Sign-in log",
		"profile": "Profile",
		"changePassword": "Change Password",
		"registerNewRecord": "Register New Record",
		"eAccreditation": "E-Accreditation",
		"arrivalDeparture": "Arrival & Departure",
		"transportation": "Transportation",
		"foodBeverages": "Food & Beverages",
		"organizationTypes": "Organization Types",
		"accessCodes": "Zone Access Codes",
		"accessDefaults": "Zone Access Rules",
		"zoneAccess": "Zone Access",
		"handoverLocations": "Card Handover Locations",
		"entryPoints": "Entry Points",
		"airlines": "Airlines",
		"registrationWindows": "Registration Windows",
		"quotas": "Quotas",
		"entryWindows": "Entry Windows",
		"nocStages": "Sector Management",
		"contingentDashboard": "Contingent Dashboard",
		"merchandising": "Merchandising",
		"changelog": "Change Logs",
		"entriesDashboard": "Entries Dashboard",
		"logisticsDesk": "Logistics Desk"
	},
	"short": {
		"home": "Home",
		"accreditation": "Accred.",
		"rooms": "Rooms",
		"helpdesk": "Helpdesk",
		"inventory": "Inventory",
		"wslInventory": "WSL Inv.",
		"reports": "Reports",
		"settings": "Settings",
		"users": "Users",
		"profile": "Profile",
		"register": "Register",
		"records": "Records",
		"shortlist": "Shortlist",
		"eAccreditation": "E-Acc",
		"arrivals": "Arrivals",
		"transport": "Transport",
		"foodBeverages": "F&B",
		"eoi": "EOI",
		"ebn": "EBN",
		"entries": "Entries",
		"logistics": "Logistics",
		"contingent": "Contingent",
		"merchandising": "Merch",
		"changelog": "Changes",
		"entriesDashboard": "Entries",
		"logisticsDesk": "Desk"
	},
	"tails": {
		"addUser": "Add User",
		"user": "User",
		"disciplines": "Disciplines",
		"category": "Category",
		"merchOrder": "Order",
		"merchProduct": "Product"
	},
	"sidebar": {
		"mainNavigation": "Main navigation",
		"accountMenu": "Account menu for {{name}}",
		"activeRole": "Active role",
		"noActiveRole": "No active role",
		"switchRole": "Switch role",
		"roleWithGroup": "{{role}} · {{group}}",
		"hostRole": "MASOC",
		"requiresTwoFactor": "Requires two-factor",
		"twoFactorBadge": "2FA",
		"changePassword": "Change password",
		"signOut": "Sign out",
		"home": "GMS home",
		"brandTitle": "SEA Games 2027",
		"brandSubtitle": "Games management system",
		"menuLabel": "Menu",
		"sectorTitle": "{{sector}} · {{name}}"
	},
	"breadcrumbs": {
		"label": "Breadcrumb"
	},
	"shell": {
		"openMenu": "Open menu",
		"closeMenu": "Close menu",
		"expandSidebar": "Expand sidebar",
		"collapseSidebar": "Collapse sidebar",
		"back": "Back",
		"gamesName": "SEA Games Malaysia 2027"
	},
	"errors": {
		"notFoundTitle": "Page not found",
		"notFoundBody": "That address doesn't match anything in the system.",
		"backToDashboard": "Back to dashboard",
		"serverUnreachable": "Server unreachable",
		"somethingWentWrong": "Something went wrong",
		"requestId": "Request ID",
		"tryAgain": "Try again",
		"dashboard": "Dashboard",
		"notFoundCode": "404",
		"notFoundHint": "Check the address for typos, or head back to the dashboard.",
		"requestedAddress": "Address you asked for:",
		"goBack": "Go back",
		"unreachableCode": "Offline",
		"errorCode": "Oops"
	},
	"toast": {
		"prefixed": "{{prefix}}: {{text}}"
	}
}
